import type { FieldSchema } from '../types';
import { formatNiceAnswer } from '../services/answerFormatter';

/**
 * Field types that render content but never collect an answer. They are still
 * instantiated as Questions so they can participate in display logic, but must
 * be excluded from validation/completeness — otherwise they fail the "Required"
 * check (no answer + not optional) and silently block step navigation.
 */
const DISPLAY_ONLY_TYPES = new Set(['Callout', 'Message', 'ReadOnly']);

export class Question {
  public id: string = '';
  public label: string = '';
  public optional: boolean = false;
  public answer: unknown = null;
  public type: string = '';

  /** True for non-interactive fields (callouts, messages) that take no answer. */
  public isDisplayOnly(): boolean {
    return DISPLAY_ONLY_TYPES.has(this.type);
  }

  public hasAnswered(): boolean {
    return this.answer !== null && this.answer !== undefined;
  }

  public hasPopulatedAnswer(): boolean {
    if (Array.isArray(this.answer)) {
      return this.answer.length > 0;
    }

    return this.hasAnswered() && this.answer !== '';
  }

  public getNiceAnswer(fieldSchema?: FieldSchema): string {
    return formatNiceAnswer(this, fieldSchema);
  }
}
